import { css } from '@emotion/core';
import { media, variables } from '@domain-group/fe-brary';
var _ref = {
  name: "fxumzl",
  styles: "padding:0 10px;"
};
var _ref2 = {
  name: "45ra3g",
  styles: "overflow:hidden;max-height:700px;"
};
export var row = function row() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    isAd = _ref5.isAd,
    isFluid = _ref5.isFluid;
  return /*#__PURE__*/css("margin-bottom:30px;", isAd && _ref, " ", isFluid && _ref2);
};
var _ref3 = {
  name: "542elh",
  styles: "padding-top:10px;"
};
export var searchContent = function searchContent() {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    hasSingleFeaturedProperty = _ref6.hasSingleFeaturedProperty,
    hasNoResult = _ref6.hasNoResult;
  return /*#__PURE__*/css("display:flex;flex-direction:row;align-items:flex-start;gap:32px;justify-content:space-between;max-width:1020px;margin-left:auto;margin-right:auto;", media('<desktop'), "{gap:24px;}", hasSingleFeaturedProperty && _ref3, " ", hasNoResult && /*#__PURE__*/css("padding-left:0;padding-right:0;", media('>=tablet'), "{max-width:none;justify-content:space-between;}"));
};
var _ref4 = {
  name: "h5fkc8",
  styles: "margin-top:32px;"
};
export var items = function items() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    hasSingleFeaturedProperty = _ref7.hasSingleFeaturedProperty;
  return /*#__PURE__*/css(hasSingleFeaturedProperty && _ref4, " ", media('>=tablet'), "{margin-top:0;margin-left:26px;}", media('>=desktop'), "{margin-left:0;}");
};
export var item = /*#__PURE__*/css("margin:0 auto;background-color:", variables.colour.white, ";");
export var left = /*#__PURE__*/css(media('<tablet'), "{width:100%;}", media('<desktop'), "{max-width:455px;}");
export var right = /*#__PURE__*/css("width:249px;margin-right:24px;display:flex;flex-direction:column;gap:12px;", media('>=desktop'), "{width:328px;margin:0;}");
export var adSpot = {
  name: "h5fkc8",
  styles: "margin-top:32px;"
};